export const getDocumentList = state => {
    return state.props
}

export const getDocumentDeletedList = state => {
    return state.deletedItems
}


// WEBPACK FOOTER //
// ./src/store/modules/document/getters.js